import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './YazimKurallari.css';

function YazimKurallari() {
  return (
    <div className="yazim-kurallari-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>BİLDİRİ YAZIM KURALLARI</h2>
          <p>Genişletilmiş Özet Hazırlama Esasları</p>
        </div>
      </header>

      <main className="content-container">
        <article className="main-card">
          {/* GENEL KURALLAR */}
          <section className="info-block">
            <p>
              Kongreye gönderilecek tüm bildiriler <strong>"Genişletilmiş Özet"</strong> biçiminde ve aşağıda belirtilen 
              "Bildiri Şablonu" formatına uygun olarak sisteme yüklenmelidir. Genişletilmiş özet, kaynakça hariç en az 
              <strong> 2000 – en çok 3000 kelime</strong> uzunluğunda olmalıdır.
            </p>
            <p>
              Bildiri şablonuna uygun olarak hazırlanan bildirilerin, "Bildiri Gönderimi" başlığı altında yer alan sistem üzerinden 
              en geç <strong>5 NİSAN 2026 PAZAR</strong> günü saat 23.59'a kadar gönderilmesi gerekmektedir.
            </p>
            <p><strong>Kongremizin dili Türkçe'dir. Türkçe dışında bir dilde sunum yapılmayacaktır.</strong></p>
          </section>

          {/* BİÇİMLENDİRME DETAYLARI */}
          <section className="info-block">
            <h3>Bildiri Yapısı ve Biçimlendirme</h3>
            <p>
              Bildiri metinleri; başlık, kısa özet, giriş, kavramsal çerçeve, araştırma yöntemi, bulgular ve tartışma, sonuç ve öneriler kısımlarından oluşmalıdır.
            </p>
            <ul>
              <li><strong>Kısa Özet:</strong> Türkçe yazılmalı, en fazla 150 kelime, 9 punto, tek satır aralığı, iki yana yaslı olmalıdır.</li>
              <li><strong>Ana Metin:</strong> 11 punto, tek satır aralığı ve iki yana yaslı olarak yazılmalıdır.</li>
              <li><strong>Sayfa Düzeni:</strong> Sol, Sağ, Üst ve Alt kenar boşlukları 3 cm olarak ayarlanmalıdır.</li>
              <li><strong>Yazar Bilgileri:</strong> Unvan, ad-soyad, kurum adı ve e-posta şeklinde belirtilmelidir.</li>
            </ul>
          </section>

          {/* BAŞLIKLAR VE TABLOLAR */}
          <section className="info-block">
            <h3>Başlık, Tablo ve Atıf Kuralları</h3>
            <p>
              Bildiri başlığı 14 punto, büyük harf ve koyu olmalıdır. Alt başlıklarda numara, italik veya alt çizgi kullanılmamalıdır. 
              Tablo ve şekil isimleri metin içinde numara sırasına göre verilmeli, kaynaklar tablonun hemen altında belirtilmelidir.
            </p>
            <div className="apa-box">
              <p>Bildirilerde metin içi atıf gösterimi ve kaynakça <strong>APA 7</strong> kurallarına uygun olarak yapılacaktır.</p>
            </div>
          </section>

          {/* DOKÜMANLAR TABLOSU (Görseldeki Tasarım) */}
          <section className="documents-section">
            <h3>Dokümanlar</h3>
            <div className="doc-table-wrapper">
              <table className="doc-table">
                <thead>
                  <tr>
                    <th>Doküman İsmi</th>
                    <th className="text-center">İndir</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Bildiri Şablonu.docx</td>
                    <td className="text-center">
                      <a href="/sablon.docx" download className="download-icon-btn">
                        <i className="fas fa-arrow-down"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>APA-7-Yazim-Kurallari-ve-Kaynak-Gosterme.pdf</td>
                    <td className="text-center">
                      <a href="/apa7.pdf" download className="download-icon-btn">
                        <i className="fas fa-arrow-down"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </article>
      </main>

      <Footer />
    </div>
  );
}

export default YazimKurallari;